<template>
    <div class="d-flex justify-content-center flex-wrap">
      <div class="face-circle rounded-circle m-1" v-for="i in maxFacesCount" :key="i">
        <span v-if="i === checkinFaces.length+1" class="btn-add-selfie" @click="$emit('click', $event)"></span>
        <span v-if="i < checkinFaces.length+1">
          <img :src="checkinFaces[i-1].face_img" alt="" class="face-img rounded-circle" height="100%" width="100%">
       </span>
      </div>
    </div>
</template>

<script>
    export default {
        props: ['checkinFaces', 'maxFacesCount'],
    }
</script>
